module.exports = __webpack_public_path__ + "img/14.b8162c42.jpg";